"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateJoyIDInfoTx = void 0;
const constants_1 = require("../constants");
const utils_1 = require("../utils");
const ckb_sdk_utils_1 = require("@nervosnetwork/ckb-sdk-utils");
const secp256r1_1 = require("../signature/secp256r1");
const generateJoyIDMetadata = (joyIDInfo) => {
    const joyIDMeta = {
        id: 'CTMeta',
        ver: '1.0',
        metadata: {
            target: 'output#0',
            type: 'joy_id',
            data: Object.assign({ version: '0' }, (0, utils_1.toSnakeCase)(joyIDInfo)),
        },
    };
    return (0, utils_1.append0x)((0, utils_1.utf8ToHex)(JSON.stringify(joyIDMeta)));
};
const generateJoyIDInfoTx = (collector, mainPrivateKey, address, joyIDInfo, fee = constants_1.FEE, isMainnet = false) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const cotaType = (0, constants_1.getCotaTypeScript)(isMainnet);
    const cotaLock = (0, ckb_sdk_utils_1.addressToScript)(address);
    const cotaCells = yield collector.getCells(cotaLock, cotaType);
    if (!cotaCells || cotaCells.length === 0) {
        throw new Error("Cota cell doesn't exist");
    }
    const cotaCell = cotaCells[0];
    const inputs = [
        {
            previousOutput: cotaCell.outPoint,
            since: '0x0',
        },
    ];
    const outputs = [cotaCell.output];
    outputs[0].capacity = `0x${(BigInt(outputs[0].capacity) - fee).toString(16)}`;
    const cotaOutput = yield collector.getLiveCell(cotaCell.outPoint);
    const outputsData = [(_a = cotaOutput.data) === null || _a === void 0 ? void 0 : _a.content];
    const cellDeps = [(0, constants_1.getCotaCellDep)(isMainnet), (0, constants_1.getJoyIDCellDep)(isMainnet)];
    const rawTx = {
        version: '0x0',
        cellDeps,
        headerDeps: [],
        inputs,
        outputs,
        outputsData,
        witnesses: [],
    };
    rawTx.witnesses = rawTx.inputs.map((_, i) => i > 0 ? '0x' : { lock: '', inputType: '', outputType: generateJoyIDMetadata(joyIDInfo) });
    const key = (0, utils_1.keyFromPrivate)(mainPrivateKey);
    const signedTx = (0, secp256r1_1.signSecp256r1Tx)(key, rawTx);
    console.info(JSON.stringify(signedTx));
    let txHash = yield collector.getCkb().rpc.sendTransaction(signedTx, 'passthrough');
    console.info(`Update joyId metadata tx has been sent with tx hash ${txHash}`);
    return txHash;
});
exports.generateJoyIDInfoTx = generateJoyIDInfoTx;
